<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="100px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="訂單備註">
        <el-input v-model="form.Remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="發票類型">
        <el-radio-group v-model="form.ReceiptType">
          <el-radio-button label="紙本發票"></el-radio-button>
          <el-radio-button label="電子發票"></el-radio-button>
        </el-radio-group>
        <!-- <el-input v-model="form.ReceiptType"></el-input> -->
      </el-form-item>
      <el-form-item label="公司抬頭">
        <el-input :disabled="form.ReceiptType!='紙本發票'" v-model="form.ReceiptPaperCompanyTitle"></el-input>
      </el-form-item>
      <el-form-item label="公司統編">
        <el-input :disabled="form.ReceiptType!='紙本發票'" v-model="form.ReceiptPaperTaxID"></el-input>
      </el-form-item>
      <el-form-item label="電子發票條碼">
        <el-input :disabled="form.ReceiptType!='電子發票'" v-model="form.ReceiptDigitalBarcode"></el-input>
      </el-form-item>
      <el-form-item label="統一編號">
        <el-input :disabled="form.ReceiptType!='電子發票'" v-model="form.ReceiptDigitalTaxID"></el-input>
      </el-form-item>
      <el-form-item label="紙本發票編號">
        <el-input :disabled="form.ReceiptType!='紙本發票'" v-model="form.TripleReceiptID"></el-input>
      </el-form-item>
      <el-form-item label="管理員備註">
        <el-input v-model="form.AdminRemark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return '編輯訂單資訊'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      let promise = this.isEdit
        ? this.$services.order.updateInfo(this, this.form)
        : this.$services.order.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.order.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.order.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.order.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown order for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      // if (!this.form.TitleTw) {
      //   errMsg = '請輸入繁中標籤'
      // }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
          }
        }
      }
    }
  }
}
</script>
